









import VueOptions from '@utils/VueOptions'
import AlertBar from '@components/AlertBar'

settings =
  vue:
    name: 'OfferAlertBar'
    props: ['offer']
    components: { AlertBar }
    computed:
      termsAccepted: -> 
        accepted = true
        accepted = (accepted and agreement.accepted) for key, agreement of @offer.offer_acceptance_agreement
        accepted
    methods: 
      alert: () ->
        return null if @offer.denied
        return @promptToTermsAlert() if !@termsAccepted
        return @promptToAcceptAlert() if @termsAccepted and @offer.pending
        return null
      promptToAcceptAlert: ->
        {
          id: @offer.id
          type: 'info'
          message: "Thanks for agreeing to the terms. You can now accept the offer."
          button: null
          dismissable: false
        }
      promptToTermsAlert: ->
        {
          id: @offer.id
          type: 'info'
          message: "Congratulations! You've received an offer. Please agree to the terms, if it is a good fit."
          button: null 
          dismissable: false
        }

export default VueOptions.vue settings
